import { render, staticRenderFns } from "./DisplayFilter.vue?vue&type=template&id=8c841c32"
import script from "./DisplayFilter.vue?vue&type=script&lang=js"
export * from "./DisplayFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c841c32')) {
      api.createRecord('8c841c32', component.options)
    } else {
      api.reload('8c841c32', component.options)
    }
    module.hot.accept("./DisplayFilter.vue?vue&type=template&id=8c841c32", function () {
      api.rerender('8c841c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventory/DisplayFilter.vue"
export default component.exports